module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-report-5.30c6d442.svg";